import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { fadeInUp } from '../services/animations/fadeInUp.animation'

import { RichTextEditor } from '@syncfusion/ej2-richtexteditor';
import { ToolbarService, LinkService, ImageService, HtmlEditorService, QuickToolbarService } from '@syncfusion/ej2-angular-richtexteditor';
import { AdminService } from '../services/admin.service';
import { CheckUrl } from '../services/validators/check-url.validator';
import { PromotionService } from '../services/promotion.service';

@Component({
	selector: 'app-promotion-strip',
	templateUrl: './promotion-strip.component.html',
	providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, QuickToolbarService],
	animations: [fadeInUp]
})

export class PromotionStripComponent implements OnInit {

	@ViewChild('toolsRTE') richEditor: RichTextEditor

	editForm: FormGroup
	promotionStripContent: any
	selectedContentText: string = null
	selectedContentValue: string = null
	selectedContentValueCopy: string = null
	buttonLabel: string = null
	buttonLink: string = null
	contentChanged: boolean = false
	richDescriptionRequiredError: boolean = false
	richDescriptionMaxLengthError: boolean = false
	richEditorContentHasErrors: boolean = false
	detailsMessage: Array<any> = []
	linksButtonClicked: boolean = false
	selectedContentForEdit: any = {}
	showPromotionStrip: boolean = false

	public tools: object = {
		items: [ 'Bold', '|', 'LowerCase', 'UpperCase', '|', 'Undo', 'Redo' ]
	}

	public myFontColor: any

	public value:any = {}

	constructor(
		private fBuilder: FormBuilder,
		private adminSevice: AdminService,
		private promotionService: PromotionService
  	) { }

	ngOnInit() {
		this.editForm = this.fBuilder.group({
			'addPromotionStrip': [false],
			// 'description': [''],
			'addCTAButton': [false],
			'buttonLabel': [null, Validators.compose([Validators.maxLength(25)])],
			'buttonLink': [null, Validators.compose([CheckUrl])]
		})
		this.getContent()
		// this.formValueChange()
		// this.checkRichEditorContent()
	}

	onCreate() {
		let def = this.richEditor.fontColor
		this.myFontColor = def
		this.myFontColor.colorCode = {
			Custom: ['#FFFFFF', '#009CCC', '#63B246']
		}
	}

	checkRichEditorContent() {
		const richValue = this.richEditor.getText()
		if (richValue == null || richValue.length === 0 || richValue === '') {
			this.richDescriptionRequiredError = true
		} else {
			this.richDescriptionRequiredError = false
			if (richValue.length === 0 || richValue.length > 100) {
				this.richEditorContentHasErrors = true
			} else {
			this.richEditorContentHasErrors = false
			}
		}
	}

	formValueChange() {
		this.editForm.valueChanges.subscribe(val => {
			this.detailsMessage = []
		})
	}

	richTextChanged(event) {
		this.detailsMessage = []
		if (this.linksButtonClicked) {
			return
		}
		const richValue = event.target.textContent
		if (richValue.length === 0 || richValue.length > 50) {
			this.richEditorContentHasErrors = true
		} else {
			this.richEditorContentHasErrors = false
		}
		if (richValue.length === 0 || richValue === '' || richValue == null) {
			this.richDescriptionRequiredError = true
		} else {
			this.richDescriptionRequiredError = false
		}
		if (richValue.length > 50) {
			this.richDescriptionMaxLengthError = true
		} else {
			this.richDescriptionMaxLengthError = false
		}
	}

	getContent() {
		this.adminSevice.getStaticContent('promotion-strip').then((res: any) => {
			if (res && res.content) {
				this.promotionStripContent = res.content
				this.populateContent()
			}
		}).catch (err => {})
	}

	populateContent() {
		if (this.promotionStripContent) {
			if (this.promotionStripContent.displayPromotionStrip) {
				this.editForm.controls['addPromotionStrip'].setValue(this.promotionStripContent.displayPromotionStrip)
			}
			if (this.promotionStripContent.stripMessageHtml) {
				this.selectedContentValue = this.promotionStripContent.stripMessageHtml
			}
			if (this.promotionStripContent.displayCTAButton) {
				this.editForm.controls['addCTAButton'].setValue(this.promotionStripContent.displayCTAButton)
			}
			if (this.promotionStripContent.buttonLabel) {
				this.editForm.controls['buttonLabel'].setValue(this.promotionStripContent.buttonLabel)
			}
			if (this.promotionStripContent.buttonLink) {
				this.editForm.controls['buttonLink'].setValue(this.promotionStripContent.buttonLink)
			}
			// this.updateValidators()
		}
	}

	updateValidators() {
		this.editForm.controls['buttonLabel'].setValidators([])
		this.editForm.controls['buttonLink'].setValidators([])
		if (this.editForm.value.addCTAButton) {
			this.editForm.controls['buttonLabel'].setValidators([Validators.required, Validators.maxLength(25)])
			this.editForm.controls['buttonLink'].setValidators([Validators.required, CheckUrl])
		}
		this.editForm.controls['buttonLabel'].updateValueAndValidity()
		this.editForm.controls['buttonLink'].updateValueAndValidity()
	}

	cancelChange() {
		console.log('cancelChange');
	}

	updateContent() {
		if (this.editForm.valid && !this.richEditorContentHasErrors) {
			const stripMessageText = (this.editForm.value.addPromotionStrip ? this.richEditor.getText() : '')
			const stripMessageHtml = (this.editForm.value.addPromotionStrip ? this.richEditor.getHtml() : '')
			const buttonLabel = (this.editForm.value.addCTAButton ? this.editForm.value.buttonLabel : '')
			const buttonLink = (this.editForm.value.addCTAButton ? this.editForm.value.buttonLink : '')
			const payload = {
				for: 'promotion-strip',
				content: {
					displayPromotionStrip: this.editForm.value.addPromotionStrip || false,
					stripMessageText: stripMessageText,
					stripMessageHtml: stripMessageHtml,
					displayCTAButton: this.editForm.value.addCTAButton || false,
					buttonLabel: buttonLabel,
					buttonLink: buttonLink
				}
			}
			this.adminSevice.updateStaticContent(payload).then((res: any) => {
				this.detailsMessage = [{ message: 'Details updated successfully' }]
				this.promotionService.promotionUpdated(res.obj)
			}).catch(err => {
				console.log(err);
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/admin/promotion-strip.component.ts